<template>
  <div id="jci-program-payment-report" class="page-container">
    <!-- Stunning Header Card -->
    <v-card elevation="20" class="header-card mb-4 overflow-hidden">
      <div class="header-gradient">
        <div class="header-content pa-5">
          <v-row align="center" justify="space-between">
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <div class="header-icon-box mr-4">
                  <v-icon size="48" color="white">mdi-receipt</v-icon>
                </div>
                <div>
                  <h1
                    class="text-h4 font-weight-bold white--text mb-1 header-title"
                  >
                    {{ PageTitle }}
                  </h1>
                  <p class="text-subtitle-1 white--text mb-0 header-subtitle">
                    <v-icon size="16" color="white" class="mr-1"
                      >mdi-information-outline</v-icon
                    >
                    Manage and track all event payment registrations
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <div class="d-flex justify-end flex-wrap gap-2">
                <!-- Refresh Button -->
                <v-btn
                  @click.prevent="refreshPageData"
                  color="rgba(255,255,255,0.2)"
                  elevation="0"
                  rounded
                  large
                  class="action-btn white--text"
                >
                  <v-icon left>mdi-refresh</v-icon>
                  Refresh
                </v-btn>

                <!-- Add Payment Button (conditional) -->
                <v-btn
                  v-if="RoleId == 2"
                  @click.prevent="addRecordPrompt = true"
                  color="#8950FC"
                  elevation="8"
                  rounded
                  large
                  class="action-btn white--text"
                >
                  <v-icon left>mdi-plus</v-icon>
                  ADD PAYMENT
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-dialog v-model="addRecordPrompt" persistent max-width="600px">
      <add-event-online-payment
        pageDescription="Add Event Online Payment"
        :addRecordPrompt="addRecordPrompt"
        @hideAddRecordPrompt="hideAddRecordPrompt"
        v-if="addRecordPrompt"
      ></add-event-online-payment>
    </v-dialog>
    <v-dialog
      v-model="transferEventPrompt"
      persistent
      scrollable
      max-width="65%"
    >
      <transfer-jci-event
        :transferEventPrompt="transferEventPrompt"
        :recordData="selectedData"
        @hidetransferEventPrompt="hidetransferEventPrompt($event)"
        v-if="transferEventPrompt"
      >
      </transfer-jci-event>
    </v-dialog>

    <!-- Filter Card -->
    <v-card elevation="8" class="filter-card mb-4">
      <v-card-text class="pa-5">
        <!-- Loading -->
        <div v-if="LoadingFlag" class="text-center py-8">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
          <p class="mt-4 text-h6 primary--text">Loading payment data...</p>
        </div>

        <v-form
          ref="form2"
          v-model="valid1"
          lazy-validation
          v-if="!LoadingFlag"
        >
          <!-- Filter Header -->
          <div class="filter-header mb-5">
            <v-icon color="primary" size="32" class="mr-2"
              >mdi-filter-variant</v-icon
            >
            <span class="text-h5 font-weight-bold primary--text"
              >Search & Filter</span
            >
          </div>

          <div class="form-section mb-4">
            <v-row wrap>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-calendar-check</v-icon
                  >
                  <span class="text-danger">*</span> Year
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="JciYearCodeOptionsLoading"
                  :items="JciYearCodeOptions"
                  :rules="JciYearCodeRules"
                  v-model="JciYearCode"
                  hint="Select a year"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-calendar-multiple"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-calendar-month</v-icon
                  >
                  Event Name <small>(optional)</small>
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="EventCodeOptionsLoading"
                  :items="EventCodeOptions"
                  :rules="EventCodeRules"
                  v-model="EventCode"
                  hint="Select a event"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-calendar-check"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-credit-card</v-icon
                  >
                  Payment Id <small>(optional)</small>
                </div>
                <v-text-field
                  v-model="PaymentId"
                  :rules="PaymentIdRules"
                  placeholder="Payment Id"
                  hint="Enter razorpay payment id"
                  persistent-hint
                  required
                  dense
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-credit-card-multiple"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-map-marker</v-icon
                  >
                  Zone <small>(optional)</small>
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="ZoneCodeOptionsLoading"
                  :items="ZoneCodeOptions"
                  :rules="ZoneCodeRules"
                  v-model="ZoneCode"
                  hint="Select a Zone"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-map-marker-radius"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-office-building</v-icon
                  >
                  LO <small>(optional)</small>
                </div>
                <v-autocomplete
                  :reduce="(option) => option.value"
                  :loading="LomCodeOptionsLoading"
                  :items="LomCodeOptions"
                  :rules="LomCodeRules"
                  v-model="LomCode"
                  hint="Select a LO"
                  persistent-hint
                  dense
                  clearable
                  required
                  outlined
                  class="custom-input"
                  prepend-inner-icon="mdi-office-building-marker"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-calendar-start</v-icon
                  >
                  From Date
                </div>
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="FromDate"
                      label="From Date"
                      hint="Select a From Date"
                      persistent-hint
                      readonly
                      v-on="on"
                      dense
                      outlined
                      class="custom-input"
                      prepend-inner-icon="mdi-calendar-range"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="FromDate"
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" lg="3" md="3">
                <div class="field-label">
                  <v-icon color="primary" size="18" class="mr-1"
                    >mdi-calendar-end</v-icon
                  >
                  To Date
                </div>
                <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      required
                      v-model="ToDate"
                      label="To Date"
                      hint="Select a To Date"
                      persistent-hint
                      readonly
                      v-on="on"
                      dense
                      outlined
                      class="custom-input"
                      prepend-inner-icon="mdi-calendar-range"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="ToDate"
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
          </div>
          <v-row wrap class="mt-4">
            <v-col align="center" cols="12" md="12">
              <v-btn
                :disabled="!valid1"
                @click.prevent="searchForm"
                :loading="SearchFlag"
                color="primary"
                elevation="8"
                x-large
                rounded
                class="search-btn font-weight-bold px-10 white--text"
              >
                <v-icon left size="24">mdi-magnify</v-icon>
                SEARCH
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-container
      class="py-0"
      v-if="!StartupLoadingFlag && ResultFlag && tableData1.length == 0"
    >
      <v-row wrap>
        <v-col align="center" cols="12" md="12">
          <h4>No records found.</h4>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="py-0"
      v-if="!StartupLoadingFlag && ResultFlag && tableData1.length == 0"
    >
      <v-row wrap>
        <v-col align="center" cols="12" md="12">
          <v-alert type="info" dense outlined icon="mdi-information">
            No records found.
          </v-alert>
        </v-col>
      </v-row>
    </v-container>

    <!-- Results Section -->
    <div v-if="tableData1.length > 0">
      <!-- Stats Bar -->
      <v-card elevation="8" class="stats-card mb-4">
        <v-card-text class="pa-4">
          <v-row align="center">
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <div class="stats-icon-box mr-3">
                  <v-icon size="32" color="white">mdi-receipt</v-icon>
                </div>
                <div>
                  <h2 class="text-h4 font-weight-bold white--text mb-0">
                    {{ tableData1.length }}
                  </h2>
                  <p class="text-subtitle-1 white--text mb-0">
                    Total Payments Found
                  </p>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <v-btn
                v-if="
                  tableData1.length > 0 &&
                  tableOptions1.DownloadButtonFlag == true
                "
                @click.prevent="
                  generateExcel(
                    tableData1,
                    tableOptions1.ExcelFields,
                    tableOptions1.ExcelFileName,
                    'My Worksheet'
                  )
                "
                color="#20B2AA"
                elevation="8"
                large
                rounded
                class="export-btn white--text"
              >
                <v-icon left>mdi-file-excel</v-icon>
                EXPORT TO EXCEL
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <!-- Search Bar -->
      <v-card elevation="8" class="search-card mb-4">
        <v-card-text class="pa-4">
          <v-text-field
            v-model="search"
            placeholder="🔍 Search records here..."
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-magnify"
            class="search-input"
          >
            <template v-slot:append>
              <v-chip v-if="search" color="success" small>
                <v-icon small left>mdi-check</v-icon>
                Searching
              </v-chip>
            </template>
          </v-text-field>
        </v-card-text>
      </v-card>
      <!-- Beautiful Data Table -->
      <v-card elevation="12" class="table-card">
        <v-data-table
          class="elevation-1 stunning-table"
          loading-text="Loading... Please wait"
          v-model="selected"
          :search="search"
          :loading="TableLoadingFlag"
          :item-key="tableOptions1.ItemKey"
          :single-select="tableOptions1.SingleSelectFlag"
          :headers="tableColumns1"
          :items="tableData1"
          :items-per-page="tableOptions1.ItemsPerPage"
          :footer-props="tableOptions1.FooterProps"
        >
          <template v-slot:[`item.ActiveStatusTxt`]="{ item }">
            <v-chip
              :color="item.ActiveStatusColor"
              draggable
              dark
              class="font-weight-bold status-chip"
              >{{ item.ActiveStatusTxt }}</v-chip
            >
          </template>
          <template v-slot:[`item.ProfilePic`]="{ item }">
            <v-avatar size="60" class="payment-avatar">
              <img :src="item.ProfilePic" alt="Profile" />
            </v-avatar>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="action-buttons">
              <v-tooltip bottom v-if="item.ApprovalFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="item.ApprovalFlag"
                    @click="previewData(item)"
                    target="_blank"
                    icon
                    small
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                    class="action-icon-btn"
                  >
                    <v-icon small> mdi-check-circle </v-icon>
                  </v-btn>
                </template>
                <span> Approve Registration </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.ReceiptFilePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="item.ReceiptFilePath"
                    target="_blank"
                    icon
                    small
                    color="success"
                    v-bind="attrs"
                    v-on="on"
                    class="action-icon-btn"
                  >
                    <v-icon small> mdi-receipt </v-icon>
                  </v-btn>
                </template>
                <span> Receipt Download </span>
              </v-tooltip>
              <v-tooltip bottom v-if="!item.NonMemberFlag">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    @click="transferToOtherEvent(item)"
                    target="_blank"
                    icon
                    small
                    color="warning"
                    v-bind="attrs"
                    v-on="on"
                    class="action-icon-btn"
                  >
                    <v-icon small> mdi-account-convert </v-icon>
                  </v-btn>
                </template>
                <span> Member transfer </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.ApplicationPath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="item.ApplicationPath"
                    target="_blank"
                    icon
                    small
                    color="error"
                    v-bind="attrs"
                    v-on="on"
                    class="action-icon-btn"
                  >
                    <v-icon small> mdi-file-pdf </v-icon>
                  </v-btn>
                </template>
                <span> Application Download </span>
              </v-tooltip>
              <v-tooltip bottom v-if="item.MemberImagePath != ''">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    :href="item.MemberImagePath"
                    target="_blank"
                    icon
                    small
                    color="info"
                    v-bind="attrs"
                    v-on="on"
                    class="action-icon-btn"
                  >
                    <v-icon small> mdi-image-area </v-icon>
                  </v-btn>
                </template>
                <span> Member Image Download </span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
    <v-dialog v-model="previewRecordPrompt" max-width="75%">
      <jci-program-payment-approval
        pageDescription="Event Registration Approval"
        @hideDialog="hidePreviewRecordPrompt($event)"
        :row="selectedData"
        v-if="previewRecordPrompt"
      ></jci-program-payment-approval>
    </v-dialog>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import AddEventOnlinePayment from "@/view/pages/erp/reports/jci-progrm/AddJcomOnlinePayment.vue";
import TransferJciEvent from "@/view/pages/erp/reports/jci-progrm/TransferJciEvent";
import JciProgramPaymentApproval from "@/view/pages/erp/reports/jci-progrm/JciProgramPaymentApproval.vue";
export default {
  mixins: [common],
  components: {
    AddEventOnlinePayment,
    TransferJciEvent,
    JciProgramPaymentApproval,
  },
  data() {
    return {
      valid1: true,
      valid2: true,
      LoadingFlag: false,
      TableLoadingFlag: false,
      StartupLoadingFlag: false,
      FloatingButtonFlag: false,
      SearchFlag: false,
      SubmitFlag: false,
      ResultFlag: false,

      rows: [],
      tableData1: [],
      tableColumns1: [],
      tableOptions1: [],
      selected: [],
      search: "",
      CurrentYearId: 0,
      selectedData: {},

      direction: "top",
      fab: true,
      fling: false,
      hover: true,
      tabs: null,
      top: false,
      right: true,
      bottom: true,
      left: false,
      transition: "slide-y-reverse-transition",

      addRecordPrompt: false,
      editRecmordPrompt: false,
      previewRecordPrompt: false,
      transferEventPrompt: false,

      zone: {},
      lom: {},

      name: "",
      nameRules: [
        (v) => !!v || "Name is required",
        (v) => (v && v.length <= 10) || "Name must be less than 10 characters",
      ],
      email: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      select: "Item 1",
      items: ["Item 1", "Item 2", "Item 3", "Item 4"],
      checkbox: false,

      JciYearCodeRules: [(v) => !!v || "Year is required"],
      JciYearCode: "",
      JciYearCodeOptions: [],
      JciYearCodeOptionsLoading: false,

      EventCodeRules: [],
      EventCode: "",
      EventCodeOptions: [],
      EventCodeOptionsLoading: false,

      PaymentId: "",
      PaymentIdRules: [],

      ZoneCodeRules: [],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      LomCodeRules: [],
      LomCode: "",
      LomCodeOptions: [],
      LomCodeOptionsLoading: false,

      FromDate: "",
      FromDateRules: [(v) => !!v || "From date is required"],
      menu1: false,

      ToDate: "",
      ToDateRules: [(v) => !!v || "To date is required"],
      menu2: false,

      SearchId: "",
      SearchIdRules: [(v) => !!v || "Search Type is required"],
      SearchIdOptions: [
        { value: "", text: "--Select Type--" },
        { value: 1, text: "By LOM" },
        { value: 2, text: "By Membership Id" },
      ],

      MembershipId: "",
      MembershipIdRules: [(v) => !!v || "Membership Id is required"],

      YearHalfId: "",
      YearHalfIdRules: [(v) => !!v || "Year Half is required"],
      YearHalfIdOptions: [
        { value: "", text: "--Select Half--" },
        { value: "First", text: "First Half" },
        { value: "Second", text: "Second Half" },
      ],

      YearIdRules: [(v) => !!v || "Year is required"],
      YearId: "",
      YearIdOptions: [],
      YearIdOptionsLoading: false,

      ApprovalDescription: "",
      ApprovalDescriptionRules: [],

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
      RoleId: "",
    };
  },
  mounted() {
    /*
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Vuetify", route: "alerts" },
      { title: "Form Inputs & Control", route: "autocompletes" },
      { title: "Fileinptus" },
    ]);
    */
  },
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        var flag = tr.PagePermissionFlag;
        console.log("PagePermissionFlag=" + flag);

        if (!flag) {
          this.$router.push("/access-denied");
        }

        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;
        this.FloatingButtonOptions = tr.FloatingButtonOptions;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var CurrentYearId = this.$session.get("CurrentYearId");
        CurrentYearId = 1;
        CurrentYearId =
          CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
        this.CurrentYearId = CurrentYearId;

        var RoleId = this.$session.get("RoleId");
        RoleId = RoleId == (null || undefined) ? "" : RoleId;
        // RoleId = 4;
        this.RoleId = RoleId;

        var todayDate = new Date().toISOString().slice(0, 10);
        console.log(todayDate);

        this.FromDate = todayDate;
        this.ToDate = todayDate;

        this.getJciYearCodeOptions();
        this.getZoneCodeOptions();
        // this.getEventCodeOptions();
      }
    },
    EventCodeOptions: function () {
      console.log("watch EventCodeOptions");
      this.EventCodeOptionsLoading = false;
    },
    ZoneCode: function () {
      console.log("watch ZoneCode");
      var ZoneCode = this.ZoneCode;
      console.log({ ZoneCode });
      this.LomCode = "";
      if (ZoneCode > 0) {
        this.getLomCodeOptions();
      }
    },
    ZoneCodeOptions: function () {
      console.log("watch ZoneCodeOptions");
      this.ZoneCodeOptionsLoading = false;
    },
    LomCodeOptions: function () {
      console.log("watch LomCodeOptions");
      this.LomCodeOptionsLoading = false;
    },
    JciYearCode: function () {
      console.log("watch JciYearCode");
      var JciYearCode = this.JciYearCode;
      console.log({ JciYearCode });
      this.EventCode = "";
      if (JciYearCode > 0) {
        this.getEventCodeOptions();
      }
    },
  },
  methods: {
    // code 1
    validate() {
      if (this.$refs.form2.validate()) {
        this.snackbar = true;
      }
    },
    hideAddRecordPrompt() {
      console.log("hideAddRecordPrompt called");
      this.addRecordPrompt = false;
    },
    resetForm() {
      this.search = "";
      this.rows = [];
      this.selected = [];
    },
    resetValidation() {
      this.$refs.form2.resetValidation();
    },
    hidePreviewRecordPrompt(flag) {
      console.log("hidePreviewRecordPrompt called");
      console.log({ flag });
      this.previewRecordPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    previewData(tr) {
      console.log("previewData called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.previewRecordPrompt = true;
        this.selectedData = tr;
      } else {
        var message = "Kindly select one record to preview";
        this.toast("error", message);
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      this.resetForm();
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "natcon_payment",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    getJciYearCodeOptions() {
      console.log("getJciYearCodeOptions called");
      var selectbox1_source = "JciYearCode";
      var selectbox1_destination = "JciYearCodeOptions";
      var selectbox1_url = "api/jci-year/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        LomCode: 3,
        ZoneCode: 2,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getZoneCodeOptions() {
      console.log("getZoneCodeOptions called");
      var yearCode = this.JciYearCode;
      console.log("yearCode=" + yearCode);
      if (yearCode != "") {
        this.ZoneCode = "";
        this.ZoneCodeOptionsLoading = true;
        var selectbox1_source = "ZoneCode";
        var selectbox1_destination = "ZoneCodeOptions";
        var selectbox1_url = "api/year-wise-lom/zone-options";
        var selectbox1_conditions_array = {
          UserInterface: 2,
          YearCode: yearCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (yearCode == "") {
          message += "Year should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getEventCodeOptions() {
      console.log("getEventCodeOptions called");

      this.EventCode = "";
      this.EventCodeOptionsLoading = true;
      var selectbox1_source = "EventCode";
      var selectbox1_destination = "EventCodeOptions";
      var selectbox1_url = "api/jci-program/options";
      var selectbox1_conditions_array = {
        UserInterface: 1,
        Year: this.JciYearCode,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getLomCodeOptions() {
      console.log("getLomCodeOptions called");
      var YearCode = this.JciYearCode;
      var ZoneCode = this.ZoneCode;
      console.log("YearCode=" + YearCode + ", ZoneCode=" + ZoneCode);
      if (YearCode != "" && ZoneCode != "") {
        this.LomCodeOptionsLoading = true;
        var selectbox1_source = "LomCode";
        var selectbox1_destination = "LomCodeOptions";
        var selectbox1_url = "api/year-wise-lom/lom-options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
          YearCode: YearCode,
          ZoneCode: ZoneCode,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      } else {
        var message = "";
        if (YearCode == "") {
          message += "Year should not be empty. ";
        }
        if (ZoneCode == "") {
          message += "Zone should not be empty. ";
        }
        this.toast("error", message);
      }
    },
    getYearCodeOptions(source, destination) {
      console.log("getYearCodeOptions called");
      // this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      // var CurrentYearId = this.CurrentYearId;
      var CurrentYearId = 1;
      console.log(
        "source=" +
          source +
          ", destination=" +
          destination +
          ", CurrentYearId=" +
          CurrentYearId
      );
      if (source != "" && destination != "") {
        this.LoadingFlag = true;
        var selectbox1_source = source;
        var selectbox1_destination = destination;
        var selectbox1_url = "api/jci-year/options";
        var selectbox1_conditions_array = {
          UserInterface: 1,
        };
        this.getSelectBoxOptions(
          selectbox1_source,
          selectbox1_destination,
          selectbox1_conditions_array,
          selectbox1_url
        );
      }
    },
    searchForm() {
      console.log("searchForm is called");

      var validate1 = this.$refs.form2.validate();
      var FromDate = this.FromDate;
      var ToDate = this.ToDate;
      console.log(
        "validate1=" +
          validate1 +
          ", FromDate=" +
          FromDate +
          ", ToDate=" +
          ToDate
      );

      if (validate1 && FromDate != "" && ToDate != "") {
        this.SearchFlag = true;
        this.tableData1 = [];
        this.zone = {};
        this.lom = {};

        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/jci-program/registration/lists";
        var upload = {
          UserInterface: 1,
          Zone: this.ZoneCode,
          Lom: this.LomCode,
          Event: this.EventCode,
          PaymentId: this.PaymentId,
          FromDate: this.FromDate,
          ToDate: this.ToDate,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            thisIns.SearchFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            var options = response.data.options;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            thisIns.tableColumns1 = options.TableHeader;
            thisIns.tableOptions1 = options.TableOptions;

            if (flag == 1) {
              thisIns.tableData1 = records;
              thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.SearchFlag = false;
          });
      } else {
        var message = "";
        if (!validate1) {
          message += "Kindly fill the required fields. ";
        }
        if (FromDate == "") {
          message += "From Date should not be empty. ";
        }
        if (ToDate == "") {
          message += "To Date should not be empty. ";
        }
        // this.toast("error", message);
        this.sweetAlert("error", message, false);
      }
    },
    hidetransferEventPrompt(flag) {
      console.log("hidetransferEventPrompt called");
      console.log({ flag });
      this.transferEventPrompt = false;
      if (flag) {
        this.searchForm();
      }
    },
    transferToOtherEvent(tr) {
      console.log("transferToOtherEvent called");
      var n1 = Object.keys(tr).length;
      console.log("n1=" + n1 + ", tr=" + JSON.stringify(tr));
      if (n1 > 0) {
        this.selectedData = tr;
        this.transferEventPrompt = true;
      } else {
        var message = "Kindly select one member to edit";
        this.toast("error", message);
      }
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
<style lang="scss" scoped>
.page-container {
  padding: 20px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
}

/* ============================================
   HEADER CARD
   ============================================ */
.header-card {
  border-radius: 20px !important;
  overflow: hidden;
  animation: slideDown 0.6s ease-out;
}

.header-gradient {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(
      circle,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 70%
    );
    animation: rotate 20s linear infinite;
  }
}

.header-content {
  position: relative;
  z-index: 1;
}

.header-icon-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 15px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  animation: float 3s ease-in-out infinite;
}

.header-title {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
  animation: fadeInUp 0.8s ease-out;
}

.header-subtitle {
  opacity: 0.95;
  animation: fadeInUp 1s ease-out;
}

.action-btn {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  font-weight: 700;
  letter-spacing: 0.5px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
  }
}

/* ============================================
   FILTER CARD
   ============================================ */
.filter-card {
  border-radius: 16px !important;
  animation: fadeIn 0.8s ease-out;
}

.filter-header {
  display: flex;
  align-items: center;
  padding-bottom: 16px;
  border-bottom: 3px solid #667eea;
  margin-bottom: 24px;
}

.form-section {
  background: linear-gradient(
    135deg,
    rgba(102, 126, 234, 0.03) 0%,
    rgba(118, 75, 162, 0.03) 100%
  );
  border: 1px solid rgba(102, 126, 234, 0.1);
  border-radius: 12px;
  padding: 20px;
}

.field-label {
  display: flex;
  align-items: center;
  font-weight: 600;
  color: #004e92;
  margin-bottom: 8px;
  font-size: 14px;

  .text-danger {
    color: #ff6b6b;
    margin: 0 4px;
  }
}

.custom-input {
  ::v-deep .v-input__slot {
    border-radius: 12px !important;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
    }
  }

  ::v-deep &.v-input--is-focused .v-input__slot {
    border-color: #667eea !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
  }
}

.search-btn {
  font-weight: 700;
  letter-spacing: 1px;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.4) !important;
  }
}

/* ============================================
   STATS CARD
   ============================================ */
.stats-card {
  border-radius: 16px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  animation: slideInLeft 0.8s ease-out;
}

.stats-icon-box {
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border-radius: 50%;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.export-btn {
  font-weight: 700;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 20px rgba(32, 178, 170, 0.4) !important;
  }
}

/* ============================================
   SEARCH CARD
   ============================================ */
.search-card {
  border-radius: 16px !important;
  animation: fadeIn 1s ease-out;
}

.search-input {
  ::v-deep .v-input__slot {
    border-radius: 50px !important;
    border: 2px solid #667eea !important;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px rgba(102, 126, 234, 0.3);
    }
  }
}

/* ============================================
   TABLE CARD
   ============================================ */
.table-card {
  border-radius: 16px !important;
  overflow: hidden;
  animation: fadeInUp 1s ease-out;
}

.stunning-table {
  ::v-deep {
    thead {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);

      th {
        color: white !important;
        font-weight: 700 !important;
        font-size: 14px !important;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        padding: 20px 16px !important;
        border: none !important;
      }
    }

    tbody tr {
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(
          90deg,
          rgba(102, 126, 234, 0.05) 0%,
          rgba(118, 75, 162, 0.05) 100%
        );
        transform: scale(1.01);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }

      td {
        padding: 16px !important;
        border-bottom: 1px solid #e0e0e0 !important;
      }
    }
  }
}

.status-chip {
  font-weight: 700;
  letter-spacing: 0.3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  }
}

.payment-avatar {
  border: 3px solid #667eea;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
  }
}

.action-buttons {
  display: grid;
  grid-template-columns: repeat(2, max-content);
  gap: 8px;
  justify-content: center;
}

.action-icon-btn {
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.2) rotate(10deg);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  }
}

.text-danger {
  color: #d32f2f;
}

/* ============================================
   ANIMATIONS
   ============================================ */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }

  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 960px) {
  .header-content {
    text-align: center;

    .d-flex {
      flex-direction: column;
      align-items: center !important;
    }

    .text-right {
      text-align: center !important;
    }
  }

  .action-btn {
    margin: 4px 0 !important;
  }
}
</style>